<template>
    <b-container>
        <b-tabs @activate-tab="onActivateTab">
            <b-tab title="Users" active>
                <users-management-tab
                    :user="user"
                    :team="team">
                </users-management-tab>
            </b-tab>
            <b-tab>
                <template #title>
                    <span
                        id="teamsTabTooltip"
                        :title="titleForTeamsTab"
                        data-toggle="tooltip"
                        data-placement="top"
                        :class="{'custom-disabled-tab': titleForTeamsTab.trim() !== ''}">
                        Teams
                    </span>
                </template>
                <multiple-team-management-tab
                    :user="user"
                    :team="team">
                </multiple-team-management-tab>
            </b-tab>
            <b-tab title="Permission Sets">
                <permission-sets-tab
                    :team="team">
                </permission-sets-tab>
            </b-tab>
        </b-tabs>
    </b-container>
</template>

<script>
import UsersManagementTab from "./team-member-management-tabs/users-management-tab.vue";
import PermissionSetsTab from "./team-member-management-tabs/permission-sets-tab.vue";
import MultipleTeamManagementTab from "./team-member-management-tabs/multiple-team-management-tab.vue";

export default {
    name: 'team-member-management',
    components: {MultipleTeamManagementTab, PermissionSetsTab, UsersManagementTab},
    props: ['user', 'team', 'hasGlobalAccess'],
    computed: {
        hasTeamEnterprisePlan() {
            return this.team.plan_id == 3;
        },
        titleForTeamsTab() {
            if(!this.hasTeamEnterprisePlan) {
                return 'Only available on Enterprise plan';
            }
            else if(!this.hasGlobalAccess) {
                return 'You have no access to this tab';
            }
            return '';
        }
    },
    mounted() {
        this.manageTabTooltip();
    },
    methods: {
        onActivateTab(newTabIndex, prevTabIndex, bvEvent) {
            if(newTabIndex === 1 && (!this.hasTeamEnterprisePlan || !this.hasGlobalAccess)) {
                bvEvent.preventDefault();
            }
        },
        manageTabTooltip() {
            const tooltipSelector = $('#teamsTabTooltip');

            tooltipSelector.tooltip('dispose');
            tooltipSelector.tooltip({
                trigger: 'hover'
            });
        }
    }
}
</script>

<style scoped>
.custom-disabled-tab {
    color: #84919a;
    background-color: transparent;
    border-color: transparent;
}
</style>
